// extracted by mini-css-extract-plugin
module.exports = {"service-report__chart":"index_service-report__chart_WSSP3"};